import { render } from "./CustomParameterAddPage.vue?vue&type=template&id=48a8b40a"
import script from "./CustomParameterAddPage.vue?vue&type=script&lang=js"
export * from "./CustomParameterAddPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__